import DashboardComponent from 'components/Dashboard';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

const Home = () => {
	const selectedCompanyPermission = useSelector(
		(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	);

	const isViewDashboardPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Dashboard',
		permission: ['view'],
	});

	useEffect(() => {
		document.title = 'CostAllocation Pro';
	}, []);

	// This used to navigate('/') when the user lacked Dashboard view permission
	// — a no-op, because the dashboard *was* "/". Now that "/" redirects here,
	// the same call would bounce between the two forever, and sending them to
	// /unauthorized instead would strand them: that route sits outside
	// GlobalLayout, so they would lose the sidebar and have no way back. The
	// page renders nothing, which is exactly what the old no-op produced.

	return <>
		{
			isViewDashboardPermission ? (
				<>
					<DashboardComponent />
				</>
			) : null
		}
	</>;
};

export default Home;
